import { DateTime } from 'luxon';

import { PaymentFrequency } from '@willow/types-iso';

import { areDatesEqual } from '../../../../utils/dates';

export const validateLoanTermMatch = ({
  loanTermMonths,
  firstPaymentDate,
  maturityDate,
  paymentFrequency,
}: {
  loanTermMonths: number;
  firstPaymentDate: Date;
  maturityDate: Date;
  paymentFrequency: PaymentFrequency;
}): boolean => {
  const monthsToAdd = 12 / paymentFrequency;
  // Monthly billing - subtract one month since a loan starting on 5/1/22 with a term of 30 years will have a maturity date of 4/1/52
  // Annual billing - subtract 12 months since a loan starting on 5/1/22 with a term of 30 years will have a maturity date of 5/1/51
  const expectedMaturityDate = DateTime.fromJSDate(firstPaymentDate)
    .plus({ months: loanTermMonths - monthsToAdd })
    .startOf('day')
    .toJSDate();

  return areDatesEqual(expectedMaturityDate, maturityDate);
};
